import type { ZodType } from "zod/v4";
import type { OcpiVersion } from "./ocpi.version";

import { OcpiSchemas as OcpiSchemasV211 } from "./v2.1.1/_schemas";
import { OcpiSchemas as OcpiSchemasV221 } from "./v2.2.1/_schemas";
import { OcpiSchemas as OcpiSchemasV22 } from "./v2.2/_schemas";
import { OcpiSchemas as OcpiSchemasV230 } from "./v2.3.0/_schemas";

export const OcpiSchemas: Record<OcpiVersion, Record<string, ZodType>> = {
  "2.1.1": OcpiSchemasV211,
  "2.2": OcpiSchemasV22,
  "2.2.1": OcpiSchemasV221,
  "2.3.0": OcpiSchemasV230,
};

export const availableVersions = Array.from(
  new Set([...Object.keys(OcpiSchemas)]),
);
